import { Dispatch, PropsWithChildren, SetStateAction, createContext, useContext } from 'react';

import useSetState from 'ahooks/es/useSetState';

export type ScrollCache = {
  [key: string]: number | null | undefined;
};

export interface ScrollCacheContextState {
  scrollCache: ScrollCache;
  setScrollCache: Dispatch<SetStateAction<ScrollCache>>;
}
export const ScrollCacheContext = createContext<ScrollCacheContextState>({
  scrollCache: {},
  setScrollCache: () => {},
});

export const ScrollCacheProvider = (props: PropsWithChildren<unknown>) => {
  const { children } = props;
  const [scrollCache, setScrollCache] = useSetState<ScrollCache>({});

  return (
    <ScrollCacheContext.Provider value={{ scrollCache, setScrollCache }}>
      {children}
    </ScrollCacheContext.Provider>
  );
};

export const useScrollCacheContext = () => useContext(ScrollCacheContext);
